/** Semestri della cassa: aprile-settembre e ottobre-marzo. */

export type TipoSemestre = 'semestre-corso' | 'semestre-precedente';

export const isVoceSemestre = (voce: string): voce is TipoSemestre =>
  voce === 'semestre-corso' || voce === 'semestre-precedente';

/**
 * Estremi del semestre rispetto a `oggi`.
 * Le date si compongono da anno e mese locali: `toISOString` sposterebbe il giorno.
 */
export function semestreDate(tipo: TipoSemestre, oggi = new Date()): { da: string; a: string } {
  const anno = oggi.getFullYear();
  const mese = oggi.getMonth() + 1;
  const aprileSettembre = (a: number) => ({ da: `${a}-04-01`, a: `${a}-09-30` });
  const ottobreMarzo = (a: number) => ({ da: `${a}-10-01`, a: `${a + 1}-03-31` });

  if (mese >= 4 && mese <= 9) {
    return tipo === 'semestre-corso' ? aprileSettembre(anno) : ottobreMarzo(anno - 1);
  }
  const annoOttobre = mese < 4 ? anno - 1 : anno;
  return tipo === 'semestre-corso' ? ottobreMarzo(annoOttobre) : aprileSettembre(annoOttobre);
}
